import api from "../../../helpers/api"

// export const getPendingCustomers = (body) => api.post('moderation-pool/get-pending-customers', {...body})

export const updatePendingCustomer = (body) => api.post('moderation-pool/moderate-customers' , {...body})

export const getPendingCustomers = (body) => api.post(`customer-staging/search`, {...body})

export const getSinglePendingCustomer = (id) => api.get(`/customer-staging/${id}`)

export const deleteSinglePendingCustomer = (id) => api.delete(`customer-staging/${id}`)

export const moderateSinglePendingCustomer = (id) => api.post(`customer-staging/moderate-create`,id)
export const moderateUpdateSinglePendingCustomer = (id) => api.post(`customer-staging/moderate-update`,id)